import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { FiCheckCircle, FiAlertCircle, FiArrowRight } from 'react-icons/fi';
import { recuperarContaConfirmarApi } from '../../Api';

const STATUS_MSG = {
    invalido: 'Link inválido. Verifique se copiou todo o link do email.',
    usado:    'Este link já foi usado. Faça login com seu email e senha.',
    expirado: 'Link expirado. Solicite uma nova ativação.',
    email_em_uso: 'O email foi cadastrado em outra conta nesse meio tempo. Solicite uma nova ativação com outro email.',
    erro:     'Algo deu errado. Tente novamente em alguns minutos.',
};

export default function ConfirmarRecuperarConta() {
    const [params] = useSearchParams();
    const token = params.get('token');
    // 'processando' | 'sucesso' | 'erro:<codigo>'
    const [estado, setEstado] = useState('processando');

    useEffect(() => {
        if (!token) { setEstado('erro:invalido'); return; }
        recuperarContaConfirmarApi({ token })
            .then(() => setEstado('sucesso'))
            .catch((err) => {
                const codigo = err.response?.data?.error || 'erro';
                setEstado(`erro:${codigo}`);
            });
    }, [token]);

    if (estado === 'processando') {
        return (
            <div style={styles.page}>
                <div style={styles.card}>
                    <div style={styles.spinnerBig} />
                    <h1 style={styles.title}>Ativando sua conta…</h1>
                    <p style={styles.subtitle}>Só um instante.</p>
                </div>
                <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
            </div>
        );
    }

    if (estado === 'sucesso') {
        return (
            <div style={styles.page}>
                <div style={styles.card}>
                    <div style={{ ...styles.icon, background: '#ECFDF5', color: '#059669' }}>
                        <FiCheckCircle size={42} />
                    </div>
                    <h1 style={styles.title}>Conta ativada!</h1>
                    <p style={styles.subtitle}>
                        Seu email já está vinculado à conta e a senha que você escolheu
                        está ativa. Faça login pra continuar.
                    </p>
                    <Link to="/login" style={styles.btnPrimary}>
                        Ir para o login <FiArrowRight size={16} />
                    </Link>
                </div>
            </div>
        );
    }

    // erro:<codigo>
    const codigo = estado.split(':')[1] || 'erro';
    const msg = STATUS_MSG[codigo] || STATUS_MSG.erro;

    return (
        <div style={styles.page}>
            <div style={styles.card}>
                <div style={{ ...styles.icon, background: '#FFF1F2', color: '#E11D48' }}>
                    <FiAlertCircle size={42} />
                </div>
                <h1 style={styles.title}>Não foi possível ativar</h1>
                <p style={styles.subtitle}>{msg}</p>
                <Link to="/recuperar-conta" style={styles.btnPrimary}>
                    Tentar de novo <FiArrowRight size={16} />
                </Link>
                <Link to="/login" style={styles.linkSec}>Voltar para o login</Link>
            </div>
        </div>
    );
}

const styles = {
    page: {
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #ECFDF5 0%, #FFFFFF 60%, #F0FDFA 100%)',
        display: 'grid', placeItems: 'center', padding: '24px 16px',
        fontFamily: "'Inter', 'Roboto', system-ui, sans-serif", color: '#0F172A',
    },
    card: {
        width: '100%', maxWidth: 440, background: '#FFFFFF', borderRadius: 16,
        boxShadow: '0 24px 48px -16px rgba(15,23,42,0.18), 0 0 0 1px rgba(15,23,42,0.04)',
        padding: '40px 32px', textAlign: 'center',
    },
    icon: {
        width: 80, height: 80, borderRadius: '50%',
        display: 'grid', placeItems: 'center', margin: '0 auto 16px',
    },
    spinnerBig: {
        width: 48, height: 48, border: '4px solid #E2E8F0',
        borderTopColor: '#059669', borderRadius: '50%',
        margin: '0 auto 18px', animation: 'spin 0.8s linear infinite',
    },
    title: { fontSize: '1.45rem', fontWeight: 800, color: '#0F172A', margin: '0 0 10px' },
    subtitle: { color: '#64748B', margin: '0 0 22px', fontSize: '0.95rem', lineHeight: 1.55 },
    btnPrimary: {
        display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 6,
        padding: '12px 22px', background: 'linear-gradient(135deg,#059669,#10B981)',
        color: '#fff', borderRadius: 10, textDecoration: 'none', fontWeight: 700, fontSize: '0.92rem',
    },
    linkSec: {
        display: 'block', marginTop: 14, color: '#059669', fontSize: '0.86rem',
        fontWeight: 600, textDecoration: 'none',
    },
};
